import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Urls } from "../utils/Constants";
import Network from "../utils/Network";
import LoginCarousel from "./carousel/LoginCarousel";

export default function Login() {
const [errors, setErrors] = useState({});
const [apiErrors, setApiErrors] = useState("");
const [mobile, setMobile] = useState("");
const [pwd, setPwd] = useState("");

const navigate = useNavigate();

const submitHandler = async (event) => {
    event.preventDefault();
    const newErrors = validateForm('login');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async function (position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                console.log(latitude,longitude);
                try{
                const param = '?username='+mobile.trim()+'&password='+pwd.trim()
                const response = await Network.post(Urls.baseUrl +'/login'+param,null);
                if(response?.data?.status === "success"){
                    setWithExpiry(response.data.token);
                    navigate('/dashboard');   
                }else{
                    const apiErrors = {apiError : response.data.message};
                    setApiErrors(apiErrors);
                }
                }catch(e){
                    console.log(e);
                }
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
        
    }
}

const validateForm = (type) => {
    const errors = {};
    if (type === 'login') {            
        if (!mobile.trim()) {
            errors.mobile = 'Mobile is required';
        } else if (mobile.length !== 10) {
            errors.mobile = 'Mobile must be at least 10 digit long';
        }
        if (!pwd) {
            errors.password = 'Password is required';
        }
    }
    return errors;
};
const setWithExpiry= (token) => {
    const now = new Date();
    const fourHoursInMs = 4 * 60 * 60 * 1000;//4 hour
    const item = {
        token: token,
        expiry: now.getTime() + fourHoursInMs, // ttl in milliseconds
    };
    localStorage.setItem('token',JSON.stringify(item));
}
  return (
    <section className="login-reg">
  <div className="overlay pt-120">
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-lg-8 col-md-8 col-sm-12 order-xl-0 order-1">
              <LoginCarousel/>
          <div className="sec-img d-rtl">
          </div>
        </div>
        <div className=" col-lg-4 col-md-4 col-sm-12">
          <div className="login_bg" style={{ padding: 13 }}>
            <div className=" text-center">
              <h2
                className="title"
                style={{
                  color: "coral",
                  fontSize: 17,
                  lineHeight: 0,
                  margin: 0,
                  "font-weight": "bold"
                }}
              >
                Log in to Continue
              </h2>
            </div>
            <form
              onSubmit={submitHandler}
              autoComplete="off"
              >
              <div className="row m-0" style={{ padding: 16 }}>
                {apiErrors && (
                    <span className="error-message">
                        {apiErrors.apiError}
                    </span>
                )}
                <div className="col-12">
                  <div className="single-input">
                    <label htmlFor="logemail">User Id</label>
                    <input
                    placeholder="Enter Mobile"
                    autoFocus={true}
                    value={mobile}
                    name="email"
                    onChange={(e) => { setMobile(e.target.value) }}
                    />
                    {errors.mobile && (
                        <span className="error-message">
                            {errors.mobile}
                        </span>
                    )}
                  </div>
                  <div className="single-input ">
                    <label htmlFor="logpassword">Your Password</label>
                    <input
                    type="password"
                    className="form-control"
                    placeholder="Enter your password"
                    value={pwd}
                    name="password"
                    onChange={(e) => { setPwd(e.target.value) }}
                    />
                    {errors.password && (
                        <span className="error-message">
                            {errors.password}
                        </span>
                    )}
                  </div>
                  <button type="submit" className="btn btn-sm btn-theme w-50 h-25 fw-bold">
                    Login
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  );
}